import { ComponentStyleConfig } from '@cloudbeds/payment-sdk';

export const Heading: ComponentStyleConfig = {
  variants: {
    h1: {
    },
    h2: {
      fontSize: () => ({ base: '18px' }),
      fontWeight: 600,
    },
    h3: {
      fontSize: () => ({ base: '14px' }),
      textTransform: 'uppercase',
      fontWeight: 600,
    },
  },
  defaultProps: {
    variant: 'h3',
  },
};
